(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-flex-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCustomFlexCarousel() {
    if (!jQuery || !jQuery.fn.slick) {
      return setTimeout(initCustomFlexCarousel, 200);
    }

    jQuery('.custom-flex-carousel').each(function () {
      const $carousel = jQuery(this);
      if ($carousel.hasClass('slick-initialized')) return;

      $carousel.slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        autoplay: false
      });
    });
  }

  initCustomFlexCarousel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
